import { UserProfileFragment } from '../../../../auth/graphql/fragments/generated/UserProfile';

export function isExternalUserHavePartnerTenants(user: UserProfileFragment) {
  const { isExternalUser, isSuperAdmin } = user;
  return isExternalUser || isSuperAdmin;
}
